import { INSURANCE_ACTION_TYPES, INSURANCE_UPDATE_ACTION_TYPES } from 'utils/actions/carrier'
import {
  getInsuranceSummary,
  getInsuranceReviewer,
  getInsurances,
} from 'apps/carrier/utils/insurance'

const defaultState = {
  loading: true,
  error: null,
  summary: null,
  reviewer: null,
  insurances: null,
}

const {
  CARRIER_INSURANCE_FAILURE,
  CARRIER_INSURANCE_REQUEST,
  CARRIER_INSURANCE_SUCCESS,
} = INSURANCE_ACTION_TYPES
const { CARRIER_INSURANCE_UPDATE_SUCCESS } = INSURANCE_UPDATE_ACTION_TYPES

const carrierInsuranceReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case CARRIER_INSURANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case CARRIER_INSURANCE_SUCCESS:
      return {
        ...state,
        summary: getInsuranceSummary(action.payload.carrierApplication),
        reviewer: getInsuranceReviewer(action.payload.carrierApplication),
        insurances: getInsurances(action.payload.carrierApplication),
        loading: false,
        error: null,
      }

    case CARRIER_INSURANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case CARRIER_INSURANCE_UPDATE_SUCCESS:
      return {
        ...state,
        summary: getInsuranceSummary(action.payload.carrierApplication),
        reviewer: getInsuranceReviewer(action.payload.carrierApplication),
        insurances: getInsurances(action.payload.carrierApplication),
      }

    default:
      return state
  }
}

export default carrierInsuranceReducer
